export default {
  PROFILE_PICTURES: 'profilePictures',
  DIVERSITIES: 'diversities',
  WHY_COMPANY: 'whyCompany',
  PRIORITIZED_BULLETS: 'prioritizedBullets',
};
